import React from 'react'
import PropTypes from 'prop-types'

import { Icon } from 'components/atoms'
import * as Component from './Modal.styles'

const Modal = (props) => {
  const { children, isFullScreen, onClickCloseModal } = props

  return (
    <Component.Modal>
      {isFullScreen && (
        <Component.CloseModal onClick={ onClickCloseModal }>
          <Icon className='icon-f-cross' />
        </Component.CloseModal>
      )}
      {children}
    </Component.Modal>
  )
}

Modal.defaultProps = {
  isFullScreen: false,
}

Modal.propTypes = {
  /** for adding child nodes */
  children: PropTypes.node.isRequired,
  /** for toggling full screen mode */
  isFullScreen: PropTypes.bool,
  /** function to close the overlay */
  onClickCloseModal: (props, propName) => {
    if (
      props.isFullScreen === true &&
      (props[propName] === undefined || typeof props[propName] !== 'function')
    ) {
      return new Error('Please provide a onClickCloseModal function!')
    }
  },
}

export default Modal
